import { createTrackEvent as trackEvent } from 'utils/segment';
import * as t from './actionTypes';

export default {
  [t.CREATE_ORGANIZATION_MEMBER_REQUEST]: trackEvent('Organization Member Created'),
  [t.UPDATE_ORGANIZATION_MEMBER_REQUEST]: trackEvent('Organization Member Updated'),
  [t.UPDATE_ORGANIZATION_MEMBERSHIP_REQUEST]: trackEvent('Organization Membership Updated'),
  [t.REMOVE_ORGANIZATION_MEMBER_REQUEST]: trackEvent('Organization Member Removed'),

  [t.CREATE_ORGANIZATION_ROLE_REQUEST]: trackEvent('Organization Role Created'),
  [t.UPDATE_ORGANIZATION_ROLE_REQUEST]: trackEvent('Organization Role Updated'),
};
